import { Link } from "react-router-dom";
import { ArrowUpRight, Play, Pause } from "lucide-react";
import { useAudio } from "../context/AudioContext";
import MediaFrame from "./MediaFrame";
import Reveal from "./Reveal";

export default function DoorCard({ artist, index }) {
  const { playTrack, toggle, track, playing } = useAudio();
  const isCurrent = artist.audio_tracks?.[0] && track?.url === artist.audio_tracks[0].url;

  const onPlay = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const t = artist.audio_tracks?.[0];
    if (!t) return;
    if (isCurrent) toggle();
    else playTrack({ ...t, artist: artist.name, accent: artist.accent });
  };

  return (
    <Reveal delay={0.08 * (index % 2)} className={index % 2 === 1 ? "lg:mt-20" : ""}>
      <Link
        to={`/artistes/${artist.id}`}
        data-testid={`artist-door-${artist.id}`}
        className="group relative block overflow-hidden border border-jm-brass/15 hover:border-jm-brass/40 transition-colors duration-500"
      >
        <div className="relative h-[380px] sm:h-[460px] lg:h-[560px] overflow-hidden">
          <div className="absolute inset-0 transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]">
            <MediaFrame
              label="JM"
              sublabel="Photographie & vidéo à venir"
              accent={artist.accent}
              image={artist.door_image || artist.hero_image}
              className="w-full h-full"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-jm-ink via-jm-ink/35 to-transparent" />
          <div className="absolute inset-0 jm-grain opacity-40 pointer-events-none" />

          <span className="absolute bottom-6 left-6 font-mono text-xs tracking-[0.3em] text-jm-bone/60">
            {String(index + 1).padStart(2, "0")}
          </span>
          <button
            data-testid={`door-play-${artist.id}`}
            onClick={onPlay}
            aria-label={`Écouter un extrait de ${artist.name}`}
            className="absolute top-5 right-5 w-11 h-11 rounded-full border border-jm-bone/30 backdrop-blur-md bg-jm-ink/40 text-jm-bone flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 hover:bg-jm-amber hover:text-jm-ink hover:border-jm-amber"
          >
            {isCurrent && playing ? <Pause size={15} /> : <Play size={15} className="ml-0.5" />}
          </button>

          <div className="absolute top-0 inset-x-0 p-7 sm:p-9">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-jm-brass mb-3">{artist.genre}</p>
            <h3 className="font-serif text-3xl sm:text-4xl lg:text-[2.75rem] text-jm-bone leading-none tracking-wide">
              {artist.name}
            </h3>
            <p className="mt-3 text-sm text-jm-smoke max-w-[52%] text-left">{artist.tagline}</p>
            <span className="mt-5 inline-flex items-center gap-2 text-[13px] tracking-wide text-jm-bone/80 group-hover:text-jm-amber transition-colors duration-300">
              Entrer dans l'univers
              <ArrowUpRight size={15} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </span>
          </div>
        </div>
      </Link>
    </Reveal>
  );
}
